export default {
  wlamb: {
    contractAddress: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    abi: require('./abi/wlambAbi.json')
  },
  lamb: {
    contractAddress: '0x8971f9fd7196e5cEE2C1032B50F656855af7Dd26',
    abi: require('./abi/lambAbi.json')
  },
  defaultChainID:3,
  walletconnectRPC:{
    1:'https://mainnet.infura.io/v3/025f727e005c486bb65394de131d0bba',
    3:'https://ropsten.infura.io/v3/025f727e005c486bb65394de131d0bba'
  }
};